var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntenatal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.29907,
    height: 126.406,
    viewBox: "0 0 126.29907 126.406",
    sodipodidocname: "Antenatal.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.724 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Antenatal",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(51.6658,56.7422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.023 V 0 C 7.614,0.012 13.348,5.792 13.36,13.445 13.366,16.979 11.954,20.337 9.386,22.9 6.869,25.413 3.598,26.794 0.172,26.794 H 0.125 C -7.326,26.767 -13.373,20.758 -13.354,13.398 -13.334,5.881 -7.47,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(84.6884,33.1425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.177,-3.241 -3.74,-5.386 -7.231,-6.122 l -8.699,-4.553 c 0,-3.096 -0.002,-6.239 -0.006,-8.281 0,0 -0.011,0 -0.012,0 0.003,-0.043 0.013,-0.083 0.013,-0.126 0,-1.18 -0.957,-2.137 -2.137,-2.137 -1.18,0 -2.137,0.957 -2.137,2.137 0,0.086 0.016,0.167 0.026,0.25 -0.008,0.001 -0.017,0.001 -0.025,0.001 0.004,1.756 0.006,3.763 0.007,5.92 l -2.14,-1.12 c -1.23,-0.586 -2.526,-0.879 -3.82,-0.879 -0.988,0 -1.974,0.171 -2.929,0.511 -2.207,0.783 -3.973,2.374 -4.974,4.477 -2.072,4.356 -0.215,9.586 4.142,11.659 l 12.166,6.694 c 1.087,0.599 2.511,0.012 2.777,-1.331 0.161,-0.81 -0.302,-1.621 -1.026,-2.019 L -28.2,-1.625 c -2.574,-1.227 -3.629,-4.199 -2.452,-6.673 0.567,-1.192 1.571,-2.095 2.827,-2.541 1.255,-0.444 2.603,-0.38 3.795,0.188 l 17.257,9.035 -0.07,0.057 c 1.302,0.563 2.293,1.541 2.829,3.016 0.865,2.385 0.169,4.491 -1.552,6.249 -3.629,3.706 -7.26,7.413 -10.966,11.041 -1.908,1.868 -4.146,3.167 -6.806,3.433 -2.757,-1.798 -6.062,-2.845 -9.654,-2.851 h -0.031 c -3.605,0 -6.921,1.045 -9.686,2.844 -2.36,-0.267 -4.425,-1.329 -6.139,-2.978 -4.147,-3.989 -6.284,-7.42 -9.868,-12.203 C -59.19,6.36 -59.62,5.75 -59.83,5.039 -60.325,3.964 -60.326,2.875 -60.283,1.493 l 0.249,-13.98 c 0.311,-1.679 1.324,-3.037 2.67,-3.882 -0.127,1.438 -0.103,2.874 0.076,4.288 0.606,4.763 2.933,9.183 6.554,12.447 l 0.112,0.088 0.236,0.157 -0.077,0.418 c -0.093,0.5 0.073,1.013 0.442,1.364 1.137,1.084 2.275,2.174 3.093,2.943 0.429,0.402 1.13,0.099 1.13,-0.489 v -1.2 c 1.259,0.593 2.549,1.052 3.84,1.36 1.22,0.284 2.435,-0.468 2.724,-1.672 0.14,-0.586 0.043,-1.193 -0.273,-1.708 -0.316,-0.515 -0.813,-0.876 -1.401,-1.015 -6.299,-1.505 -11.079,-6.835 -11.896,-13.262 -0.292,-2.302 -0.709,-3.958 0.411,-5.958 0.515,-0.92 1.716,-2.024 -3.677,-2.063 -2.945,-0.022 -4.23,1.715 -4.23,1.715 -1.752,1.415 -3.014,3.431 -3.45,5.78 0,0 -0.337,14.55 -0.364,14.836 -0.196,3.848 0.348,5.888 2.319,8.292 3.578,4.366 5.706,8.204 9.986,12.321 1.56,1.5 3.331,2.619 5.233,3.332 -2.539,3.053 -4.06,7.005 -4.071,11.382 -0.026,9.712 7.93,17.642 17.734,17.678 h 0.063 c 4.565,0 8.906,-1.825 12.23,-5.142 3.379,-3.372 5.236,-7.806 5.229,-12.485 -0.008,-4.379 -1.524,-8.339 -4.06,-11.399 2.104,-0.772 4.081,-2.053 5.906,-3.84 3.741,-3.662 7.447,-7.446 11.03,-11.105 C 0.451,7.666 1.368,3.768 0,0 m -12.313,54.517 c -23.939,14.827 -55.323,5.75 -67.653,-19.566 -10.557,-21.675 -2.869,-48.255 17.628,-60.949 23.938,-14.825 55.321,-5.75 67.651,19.564 10.558,21.675 2.871,48.256 -17.626,60.951",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenatal);
export default __webpack_public_path__ + "static/media/antenatal.f9dbe5d445bdc120b9e03ce6cdca2dc1.svg";
export { ForwardRef as ReactComponent };